import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IconField } from 'primeng/iconfield';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import CarClassWriteDTO from '../../../../../../types/car-class/CarClassWriteDTO';
import { CarClassService } from '../../../../services/car-class.service';

@Component({
    selector: 'app-create-car-class-dialog',
    templateUrl: './create-car-class-dialog.component.html',
    styleUrls: [ './create-car-class-dialog.component.scss' ],
    imports: [
        DialogModule,
        InputTextModule,
        ButtonModule,
        FormsModule,
        IconField,
        InputIcon,
        IftaLabelModule,
    ]
})
export class CreateCarClassDialogComponent {
    @Input() visible: boolean = false;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() carClassCreated: EventEmitter<CarClassWriteDTO> = new EventEmitter<CarClassWriteDTO>();

    constructor(private carClassService: CarClassService,
                private messageService: MessageService) {
    }

    public carClass: CarClassWriteDTO = new CarClassWriteDTO({});

    public loading = false;

    get saveDisabled(): boolean {
        return !this.carClass.name || !this.carClass.label;
    }

    public close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }

    public saveCarClass() {
        this.loading = true;
        this.carClassService.createCarClass(this.carClass).then(() => {
            this.carClassCreated.emit(this.carClass);
            this.close();
        }).catch((error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
        }).finally(() => {
            this.carClass = new CarClassWriteDTO({});
            this.loading = false;
        });
    }
}
